import { Icon } from "@/components/Icon";
import { DynamicFormItemProps, DictMap } from "../trade/components/DynamicForm/DynamicForm";
export const formItems: DynamicFormItemProps[] = [{
  fieldLabel: '币种',
  fieldName: 'paymentType',
  fieldType: '3',
  extra: <Icon name={'exchange'} size={'0.18rem'} />
}, {
  fieldLabel: '主网',
  fieldName: 'mainNet',
  fieldType: '1',
  readOnly: true
}, {
  fieldLabel: '钱包地址',
  fieldName: 'address',
  fieldType: 'CopyIcon',
  readOnly: true
}, {
  fieldLabel: '转入数量',
  fieldName: 'amount',
  fieldType: '2'
}, {
  fieldLabel: ({
    data
  }: any) => data.paymentType ? `${data.paymentType}价格：￥${data.otcTicker}` : `汇率：￥0.00`,
  fieldName: 'current',
  fieldType: 'CurrentVB',
  readOnly: true
}];
export const dictMap: DictMap = {
  paymentType: [[{
    value: "USDT",
    text: 'USDT'
  }
  // {value: "TRX",text: 'TRX'},
  ]]
};